import { mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  name: "exchange-auto-complete",
  components: {},
  // props: ["list", "selected", "isDisabled"],
  props: {
    appendIcon: {
      type: String,
      required: false,
      default: "$dropdown"
    },
    list: {
      type: Array
    },
    selected: {
      type: String
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      search: "",
      imageBaseUrl: process.env.VUE_APP_IMAGE_BASE_URL
    };
  },
  computed: {
    filterResult() {
      if (this.list) {
        return this.list.filter(elem => {
          return (
            elem.name_locale
              .replace(/[^\p{L}]/gu, "")
              .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, "")) ||
            elem.name
              .replace(/[^\p{L}]/gu, "")
              .toLowerCase()
              .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, "")) ||
            elem.iso
              .replace(/[^\p{L}]/gu, "")
              .toLowerCase()
              .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, ""))
          );
        });
      }
    }
  },
  mounted() {},
  methods: {
    ...mapActions({
      queryIsoAction: types.operations.actions.SET_OPERATION_QUERY_ISO
    }),
    handleChange(value) {
      this.$emit("change", value);
      this.queryIsoAction(value);
    },
    handleSearch() {
      this.search = "";
    }
  }
};
